import { useState } from "react";
import { useDispatch } from "react-redux";

import { LabOrder } from "pwapi";

import { cancelLabOrder } from "shared/actions/labOrdersActions";
import Menu from "shared/components/Menu";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";

import PopUpDialog from "../PopUpDialog";

const OrderCancellationButton = ({ order }: { order: LabOrder }) => {
  const dispatch = useDispatch();

  const [isWarningOpen, setIsWarningOpen] = useState<boolean>(false);

  const onHandleConfirm = () => {
    order.id &&
      dispatch(cancelLabOrder({ id: order.id })).then(() =>
        setIsWarningOpen(false)
      );
  };

  return (
    <>
      {isWarningOpen && (
        <PopUpDialog
          onClose={() => setIsWarningOpen(false)}
          portalToBody={true}
          title="Cancel this order"
          type="warning"
        >
          <div className="CaseWarningDialog">
            <p>Cancel this lab order?</p>
            {/* {hasDeleteError && (
            <p className="errorMessage">
              Unexpected error occurred while attempting to delete this block.{" "}
              Please contact support to identify the issue.
              <br />
              <a href={SUPPORT_EMAIL_MAILTO}>
                {SUPPORT_EMAIL}
              </a>
            </p>
          )} */}
            <div className="actions__container">
              <PathologyWatchButton onClick={() => setIsWarningOpen(false)}>
                Cancel
              </PathologyWatchButton>
              <PathologyWatchButton
                type="submit"
                color="red"
                testId="order_confirm_cancel"
                onClick={() => onHandleConfirm()}
              >
                Confirm
              </PathologyWatchButton>
            </div>
          </div>
        </PopUpDialog>
      )}
      <Menu.Item icon="times" onClick={() => setIsWarningOpen(true)}>
        Cancel Order
      </Menu.Item>
    </>
  );
};

export default OrderCancellationButton;
